module.exports = __webpack_public_path__ + "img/partner_icon20.f80c2e06.png";